// removed by extract-text-webpack-plugin
module.exports = {"borderBottom":"OGHXb0bpe0i-jZO9lgiOn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyList/style.css
// module id = 669
// module chunks = 0